import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Readable text for a failed API call, or undefined. FastAPI sends `detail`
// as a string for most errors but as a list of {loc, msg, ...} objects for a
// 422, and rendering that list as a React child blanks the page.
export function errorDetail(e) {
  const d = e?.response?.data?.detail;
  if (d == null || d === "") return undefined;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && (x.msg || x.message)) || String(x)).join("; ");
  return d.message || d.msg || JSON.stringify(d);
}
